import { getApiUrl } from '@cp/src/utils/ApiHelper';
import { Dispatch } from '@reduxjs/toolkit';
import axiosInstance, { ApiKeys, logError } from '@cp/src/utils/ApiHelper';
import { getFileDownload } from '@cp/src/utils/commonUtils';
import { toast } from '@navi/web-ui/lib/primitives/Toast/core/toast';
import { setUploadAddressHistory } from '../reducer/uploadHistorySlice';
import { ADDRESS_INGESTION_FILE_STATUS } from '../constants';

export const getOriginalFile = (fileReferenceId: string) => {
  const apiUrl = getApiUrl(ApiKeys.ADDRESS_INGESTION_GET_FILE, {}, { entityId: fileReferenceId });
  axiosInstance
    .get(apiUrl)
    .then(response => {
      const fileUrl = response?.data?.presignedUrl;
      if (fileUrl) {
        getFileDownload(fileUrl);
      }
    })
    .catch(error => {
      logError(error, 'Error downloading address ingestion file');
    });
};

export const fetchErrorReport = (fileReferenceId: string) => {
  const apiUrl = getApiUrl(
    ApiKeys.ADDRESS_INGESTION_ERROR_REPORT,
    {},
    { entityId: fileReferenceId }
  );
  axiosInstance
    .get(apiUrl)
    .then(response => {
      const fileUrl = response?.data?.presignedUrl;
      if (fileUrl) {
        getFileDownload(fileUrl);
      }
    })
    .catch(error => {
      logError(error, 'Error downloading address ingestion error report');
    });
};

export const fetchUploadHistory = () => (dispatch: Dispatch) => {
  const url = getApiUrl(ApiKeys.ADDRESS_INGESTION_USER_HISTORY);
  axiosInstance
    .get(url)
    .then(response => {
      if (response?.data) {
        dispatch(setUploadAddressHistory(response.data));
      }
    })
    .catch(error => {
      logError(error, 'Error inside fetchUploadHistory');
    });
};

export const submitAddressIngestionFile = async (referenceId: string) => {
  const apiUrl = getApiUrl(
    ApiKeys.ADDRESS_INGESTION_FILE_SUBMIT,
    {},
    {
      entityId: referenceId
    }
  );

  const response = await axiosInstance.post(apiUrl);

  if (response?.data?.status === ADDRESS_INGESTION_FILE_STATUS.INPROGRESS) {
    toast.info(
      <div className="text-sm">
        File upload in progress... Please check the <br /> Upload History for status.
      </div>
    );
  }

  return response;
};
